import { createEntityHandler } from './CreateEntityStmt';
import { removeEntityHandler } from './RemoveEntityStmt';
import { renameEntityHandler } from './RenameEntityStmt';
export * from './CreateEntityStmt';
export * from './entityInstruction';
export * from './RemoveEntityStmt';
export * from './RenameEntityStmt';
export const entityHandlers = [createEntityHandler, removeEntityHandler, renameEntityHandler];
//# sourceMappingURL=index.js.map